import { useQuery } from '@tanstack/react-query';
import currencyService from 'v2/services/currency';

export function useCurrencies() {
  return useQuery({
    queryKey: ['currencies'],
    queryFn: () => currencyService.list(),
  });
}
